export default {
    title: 'AI 模型配置',
    permissionAlert: '本页配置仅管理员可修改。API Key 由系统管理员在后端加密配置，此处仅做业务侧开关与模型勾选。',
    providerSection: '通用模型配置',
    imageModelSection: '图片模型配置',
    taskSection: '任务模型分配',
    taskDesc: '为不同 AI 任务指定使用的模型',
    usageSection: '用量统计（本月）',
    connected: '● 已接入',
    notConnected: '○ 未接入',
    connectionStatus: '接入状态',
    errorStatus: '接入异常',
    unknownStatus: '未知',
    errorHint: 'API 接入异常，请联系系统管理员排查',
    connectedStatus: '已接入',
    notConnectedStatus: '未接入',
    availableModels: '可用模型',
    checkHint: '勾选后可在 AI 任务中使用该模型',
    notConnectedHint: '需联系系统管理员在后端完成接入',
    recommended: '推荐',
    adminOnlyTooltip: '仅管理员可修改',
    toggleFailed: '操作失败，请稍后重试',
    saveOk: '配置已保存',
    noModels: '暂时没有可使用的模型',
    modelConfigNotFound: '未找到模型配置，请刷新后重试',
    configServiceUnavailable: 'AI 配置服务暂不可用，请稍后重试',
    provider: {
      anthropic: 'Anthropic (Claude)',
      openai: 'OpenAI (GPT)',
      google: 'Google (Gemini)',
    },
    task: {
      name: '任务',
      desc: '说明',
      primary: '主模型',
      backup: '备用模型',
      noBackup: '不使用备用',
      random: '随机轮询',
      primaryRequired: '请先配置主模型',
      articleGen: '📝 文章生成',
      articleGenDesc: '完整文章 + FAQ + Meta',
      keywordMining: '🔑 关键词挖掘',
      keywordMiningDesc: 'AI 挖掘关键词',
      scoring: 'SEO/GEO 评分',
      scoringDesc: 'AI 辅助评分建议',
    },
    usage: {
    title: 'AI 用量统计（本月）',
    callCount: '调用次数',
    totalTokens: 'Token 消耗',
    cost: '本月费用',
    dataSourceStub: '数据为占位，待 ES 接通后显示真实数据',
    byModelTitle: '各模型明细',
    modelName: '模型',
    provider: '供应商',
    callCountCol: '调用次数',
    costCol: '费用(USD)',
  },
    backupHint: '✓ 备用模型：主模型调用失败时（限流/余额不足/超时）自动切换到备用模型，保证功能不中断。每日上限：单任务当日调用达到上限后暂停继续调用，防止操作异常费用。',
};
